module.exports = __webpack_public_path__ + "files/141d5e5481ad1017cc5f8c7e5e896063.png";